// src/data/products.js
import slide1 from '../assets/img/bg.jpg';
import Banner1 from '../assets/img/banner_img.png';
import Icon1 from '../assets/img/icon1.png';
import Studio from '../assets/img/uniform.jpg';

import Inter1 from '../assets/img/pro_inter_1.svg';
import Inter2 from '../assets/img/pro_inter_2.svg';
import Inter3 from '../assets/img/pro_inter_3.svg';
import Inter4 from '../assets/img/pro_inter_4.svg';
import Inter5 from '../assets/img/pro_inter_5.svg';
import Inter6 from '../assets/img/pro_inter_6.svg';
import Inter7 from '../assets/img/pro_inter_7.svg';
import Icon2 from '../assets/img/Shape.svg';
import Con1 from '../assets/img/confort_1.svg';
import Con2 from '../assets/img/confort_2.svg';
import Con3 from '../assets/img/confort_3.svg';
import Con4 from '../assets/img/confort_4.svg';
import Con5 from '../assets/img/confort_5.svg';
import Con6 from '../assets/img/confort_two.svg';
import Con7 from '../assets/img/confort_7.svg';

import Ser1 from '../assets/img/service_1.jpg';
import Ser2 from '../assets/img/service_2.jpg';
import Ser3 from '../assets/img/service_3.jpg';

import Brand1 from '../assets/img/brand_bg.svg';
import Logo1 from '../assets/img/khazana.svg';
import Logo2 from '../assets/img/mercedes.svg';
import Logo3 from '../assets/img/jktyre.svg';
import Logo4 from '../assets/img/esro.svg';
import Logo5 from '../assets/img/emerald.svg';
import Logo6 from '../assets/img/noku.jpg';
import Logo7 from '../assets/img/muru.svg';
import Logo8 from '../assets/img/hindusthan.svg';
import Logo9 from '../assets/img/lily_beach.svg';
import Logo10 from '../assets/img/volvo.svg';
import Logo11 from '../assets/img/coco.svg';
import Logo12 from '../assets/img/parrys.svg';
import Logo13 from '../assets/img/mrf.svg';
import Logo14 from '../assets/img/ashok.svg';
import Logo15 from '../assets/img/eicher.svg';
import Logo16 from '../assets/img/sundram.svg';
import Logo17 from '../assets/img/hwashin.svg';
import Logo18 from '../assets/img/tvs.svg';
import Logo19 from '../assets/img/the_ritz.svg';
import Logo20 from '../assets/img/kureghivaru.svg';
import Logo21 from '../assets/img/island.svg';

import Get1 from '../assets/img/get_in_touch_bg.jpg';
import Get2 from '../assets/img/get-in-tuch.png';

import Pro1 from '../assets/img/process_img_1.svg';
import Pro2 from '../assets/img/arrow_right.svg';
import Pro3 from '../assets/img/process_img_2.svg';
import Pro4 from '../assets/img/arrow_right.svg';
import Pro5 from '../assets/img/process_img_3.svg';
import Pro6 from '../assets/img/arrow_right.svg';
import Pro7 from '../assets/img/process_img_4.svg';
import Pro8 from '../assets/img/arrow_down.svg';
import Pro9 from '../assets/img/process_img_5.svg';
import Pro10 from '../assets/img/back_arrow.svg';
import Pro11 from '../assets/img/process_img_6.svg';
import Pro12 from '../assets/img/back_arrow.svg';
import Pro13 from '../assets/img/process_img_7.svg';

import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';




import manufact from '../assets/img/manufact.png';
import imgta from '../assets/img/imgta.jpg';

import manpro1 from '../assets/img/product/man-pro1.jpg';
import manpro2 from '../assets/img/product/man-pro2.jpg';
import manpro3 from '../assets/img/product/man-pro3.jpg';
import manpro4 from '../assets/img/product/man-pro4.jpg';
import manpro5 from '../assets/img/product/man-pro5.jpg';
import manpro6 from '../assets/img/product/man-pro6.jpg';
import manpro7 from '../assets/img/product/man-pro7.jpg';
import manpro8 from '../assets/img/product/man-pro8.jpg';

import monser1 from '../assets/img/product/ser1.jpg';
import monser2 from '../assets/img/product/ser2.jpg';
import monser3 from '../assets/img/product/ser3.jpg';


import govbg from '../assets/img/product/govimg.png';
import govabout from '../assets/img/product/govabout.png';



import govpro1 from '../assets/img/product/gov-pro1.jpg';
import govpro2 from '../assets/img/product/gov-pro2.jpg';
import govpro3 from '../assets/img/product/gov-pro3.jpg';
import govpro4 from '../assets/img/product/gov-pro4.jpg';
import govpro5 from '../assets/img/product/gov-pro5.jpg';
import govpro6 from '../assets/img/product/gov-pro6.jpg';

import govser1 from '../assets/img/product/ser4.jpg';
import govser2 from '../assets/img/product/ser5.jpg';

import aviimg from '../assets/img/product/aviimg.png';
import aviabout from '../assets/img/product/aviabout.jpg';

import avipro1 from '../assets/img/product/avi-pro1.jpg';
import avipro2 from '../assets/img/product/avi-pro2.jpg';
import avipro3 from '../assets/img/product/avi-pro3.jpg';
import avipro4 from '../assets/img/product/avi-pro4.jpg';
import avipro5 from '../assets/img/product/avi-pro5.jpg';
import avipro6 from '../assets/img/product/avi-pro6.jpg';

import aviSer6 from '../assets/img/product/ser6.jpg';
import aviSer7 from '../assets/img/product/ser7.jpg';


import healthcareimg from '../assets/img/product/healthcare.png';
import healthcareabout from '../assets/img/product/healthcareabout.jpg';

import healthcarepro1 from '../assets/img/product/healthcare-pro1.jpg';
import healthcarepro2 from '../assets/img/product/healthcare-pro2.jpg';
import healthcarepro3 from '../assets/img/product/healthcare-pro3.jpg';
import healthcarepro4 from '../assets/img/product/healthcare-pro4.jpg';
import healthcarepro5 from '../assets/img/product/healthcare-pro5.jpg';
import healthcarepro6 from '../assets/img/product/healthcare-pro6.jpg';

import retailimg from '../assets/img/product/retail.png';
import retailabout from '../assets/img/product/retailabout.jpg';

import retailpro1 from '../assets/img/product/retail-pro1.jpg';
import retailpro2 from '../assets/img/product/retail-pro2.jpg';
import retailpro3 from '../assets/img/product/retail-pro3.jpg';
import retailpro4 from '../assets/img/product/retail-pro4.jpg';
import retailpro5 from '../assets/img/product/retail-pro5.jpg';
import retailpro6 from '../assets/img/product/retail-pro6.jpg';

import retailSer6 from '../assets/img/product/ser8.jpg';
import retailSer7 from '../assets/img/product/ser9.jpg';

import educationalpro1 from '../assets/img/product/educational-pro1.jpg';
import educationalpro2 from '../assets/img/product/educational-pro2.jpg';
import educationalpro3 from '../assets/img/product/educational-pro3.jpg';
import educationalpro4 from '../assets/img/product/educational-pro4.jpg';
import educationalpro5 from '../assets/img/product/educational-pro5.jpg';
import educationalpro6 from '../assets/img/product/educational-pro6.jpg';
import educationalpro7 from '../assets/img/product/educational-pro7.jpg';

import educationalimg from '../assets/img/product/educational.png';
import educationalabout from '../assets/img/product/educationalabout.jpg';


export const products = [
  {
    title: "Industrial & Manufacturing",
    slug: "industrial-manufacturing",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Purpose-built uniforms balancing durability, safety, and everyday wearability",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Purpose-built uniforms balancing durability, safety, and everyday wearability",
        img: manufact,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Workwear Tailored for Tough Environments",
        text: "In industrial and manufacturing settings, uniforms are more than clothing—they’re a vital layer of safety, performance, and identity. Our workwear is built to withstand demanding conditions while ensuring comfort for long hours on the job. From high-visibility gear to specialized protective apparel, each piece is designed to keep your team safe, confident, and ready for any task. We collaborate closely with you to create role-specific uniforms that meet industry standards while reflecting your company’s professionalism.",
        img: imgta
      },
      industries: {
        heading: "Workwear for Every Role",
        text: "From machine operators to engineers—uniforms designed to perform",
        title1: "Production Floor Operators", img1: manpro2,
        title2: "Welders / Hot Work Crew", img2: manpro3,
        title3: "Maintenance & Utilities", img3: manpro4,
        title4: "Quality / Lab Technicians", img4: manpro5,
        title5: "Warehouse & Logistics", img5: manpro8,
        title6: "Supervisors & Field Engineers", img6: manpro7,
        title7: "Executive & Client-Facing", img7: manpro6,
        title8: "Outdoor / Cold Zone Staff", img8: manpro1,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: monser1 },
        { title: "Logo embroidery", text: "color matching", img: monser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: monser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Retail and Brand Spaces",
    slug: "retail-brand-spaces",
    meta: {
      title: "Retail and Brand Spaces",
      description: "Polished uniforms designed to strengthen brand presence and connect with customers",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Retail and Brand Spaces",
        text: "Polished uniforms designed to strengthen brand presence and connect with customers",
        img: retailimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Great Workwear for Lasting Brand Impact",
        text: "In retail, your team is the face of your brand. Our uniforms are designed to balance style, comfort, and brand alignment, ensuring your staff not only look sharp but also feel confident on the floor. From luxury brand stores to bustling retail outlets, we create apparel that enhances customer interactions and reinforces your brand identity at every touchpoint.",
        img: retailabout
      },
      industries: {
        heading: "Uniforms for Every Team Member",
        text: "From sales associates to store managers—uniforms designed for presence and performance",
        title1: "Retail Floor Staff", img1: retailpro1,
        title2: "POOL SIDE", img2: retailpro2,
        title3: "Corporate Executives", img3: retailpro3,
        title4: "Guest Relations / FO", img4: retailpro4,
        title5: "Event Crew", img5: retailpro5,
        title6: "Managers", img6: retailpro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: retailSer7 },
        { title: "Logo embroidery", text: "color matching", img: retailSer6 },
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Aviation",
    slug: "corporate-admin",
    meta: {
      title: "Aviation",
      description: "Workwear designed for polished appearances, brand ethos and all-day comfort at work",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Aviation",
        text: "Workwear designed for polished appearances, brand ethos and all-day comfort at work",
        img: aviimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Corporate Attire that Commands Respect",
        text: "In the corporate world, every detail speaks for your brand. Our uniforms for administrative and corporate teams are designed to project confidence, professionalism, and respect, while offering all-day comfort. From client-facing executives to support staff, we create cohesive workwear collections that strengthen your organization’s identity and leave a lasting impression.",
        img: aviabout
      },
      industries: {
        heading: "Uniforms for Every Professional Role",
        text: "From receptionists to administrative staff—uniforms designed for confidence and comfort",
        title1: "CABIN cREW", img1: avipro1,
        title2: "Lounge & Hospitality", img2: avipro2,
        title3: "PILOTS", img3: avipro3,
        title4: "GROUND STAFF", img4: avipro4,
        title5: "F&B & In-flight Services", img5: avipro5,
        title6: "Airport Security", img6: avipro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: aviSer7 },
        { title: "Logo embroidery", text: "color matching", img: aviSer6 },
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Healthcare, Clinics and Wellness",
    slug: "healthcare-clinics-wellness",
    meta: {
      title: "Healthcare, Clinics and Wellness",
      description: "Purpose-built apparel for care providers, combining hygiene, comfort, and trust",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Healthcare, Clinics and Wellness",
        text: "Purpose-built apparel for care providers, combining hygiene, comfort, and trust",
        img: healthcareimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Professional Attire for Every Caregiver",
        text: "In healthcare, uniforms go beyond appearance—they build trust and ensure functionality. Our designs for doctors, nurses, clinicians, and wellness professionals are crafted for comfort, hygiene, and all-day performance, allowing your team to focus on what matters most: patient care. Whether in clinics, hospitals, or wellness centers, we create attire that supports your team while reflecting your organization’s values.",
        img: healthcareabout
      },
      industries: {
        heading: "Uniforms for Every Care Role",
        text: "From doctors to therapists—workwear tailored for care and comfort",
        title1: "DOCTORS", img1: healthcarepro1,
        title2: "LAB TECHNICIANS", img2: healthcarepro2,
        title3: "NURSES", img3: healthcarepro3,
        title4: "OT STAFF", img4: healthcarepro4,
        title5: "RECEPTION & ADMIN", img5: healthcarepro5,
        title6: "PATIENTS WEAR", img6: healthcarepro6,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Educational Institutions",
    slug: "educational-institutions",
    meta: {
      title: "Educational Institutions",
      description: "Smart, comfortable uniforms designed for students, educators, and staff",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Educational Institutions",
        text: "Smart, comfortable uniforms designed for students, educators, and staff",
        img: educationalimg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Dressing for Learning and Leadership",
        text: "In education, uniforms foster unity, discipline, and institutional pride. Our designs for students, teachers, college faculty, and support staff are crafted for comfort, durability, and ease of wear, ensuring they meet the demands of active academic environments. From formal school attire to functional college and staff uniforms, we create collections that reflect your institution’s values while promoting confidence and belonging.",
        img: educationalabout
      },
      industries: {
        heading: "Dressing Every Role in Education",
        text: "From students to faculty—designed for learning, leading, and inspiring",
        title1: "Primary School", img1: educationalpro1,
        title2: "Middle School", img2: educationalpro2,
        title3: "Sports Uniform", img3: educationalpro3,
        title4: "Kindergarten (KG)", img4: educationalpro4,
        title5: "High School", img5: educationalpro5,
        title6: "Higher Education", img6: educationalpro6,
        title7: "Rainwear", img7: educationalpro7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Government, Police & Defense",
    slug: "government-police-defense",
    meta: {
      title: "Government, Police & Defense",
      description: "Apparel that reflects honor, authority, and commitment to public service",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Government, Police & Defense",
        text: "Apparel that reflects honor, authority, and commitment to public service",
        img: govbg,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Uniforms Built for Duty and Honour",
        text: "In service to the nation, uniforms carry a deeper meaning—symbolizing discipline, integrity, and authority. Our designs for government departments, law enforcement, and defense personnel are crafted to meet rigorous standards of functionality, durability, and respect. From ceremonial attire to everyday duty wear, each piece is designed to support those who serve with pride and purpose.",
        img: govabout
      },
      industries: {
        heading: "Uniforms for Every Rank and Role",
        text: "From officers to administrative staff—uniforms tailored for service and respect",
        title1: "Infantry / Field Force", img1: govpro1,
        title2: "Officer Class", img2: govpro6,
        title3: "Parade / Ceremonial Units", img3: govpro4,
        title4: "Traffic & Patrol Police", img4: govpro5,
        title5: "Special Ops / Tactical", img5: govpro3,
        title6: "Administration / Office", img6: govpro2,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: govser1 },
        { title: "Logo embroidery", text: "color matching", img: govser2},
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "bed-linens",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "roller-blinds",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "curtains",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "bathroom-furnishing",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "uniform-packaging",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "logo-embroidery",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "accessories",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
     testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Industrial & Manufacturing",
    slug: "sachets",
    meta: {
      title: "Industrial & Manufacturing",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Industrial & Manufacturing",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort and practicality.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  {
    title: "Hospitality & Resorts",
    slug: "hospitality-resorts",
    meta: {
      title: "Hospitality & Resorts",
      description: "Uniforms that inspire your team, impress guests, and elevate hospitality",
      keywords: "uniforms, hospitality, hotels"
    },
    content: {
      banner: {
        heading: "Hospitality & Resorts",
        text: "Uniforms that inspire your team, impress guests, and elevate hospitality",
        img: Banner1,
        bg: slide1,
        Iconbtn: Icon1,
      },
      ambience: {
        heading: "Tailored Uniforms for Hospitality Excellence",
        text: "In hospitality, first impressions last. Our uniforms for hotels, resorts, and restaurants are designed to balance style, comfort, and practicality, ensuring your team feels confident and looks the part. From front desk to housekeeping, every piece is crafted to enhance guest experience while representing your property’s unique identity. We collaborate closely with you to create attire that aligns with your brand vision and elevates every guest interaction.",
        img: Studio
      },
      industries: {
        heading: "Uniform for Every Role",
        text: "From chefs to concierge—uniforms designed with purpose",
        title1: "CHEFS", img1: Inter1,
        title2: "MANAGEMENT", img2: Inter2,
        title3: "HOUSE KEEPING", img3: Inter3,
        title4: "GARDENING STAFF", img4: Inter4,
        title5: "F&B STAFF", img5: Inter5,
        title6: "BOAT CREWS", img6: Inter6,
        title7: "POOL SIDE", img7: Inter7,
      },
      process: {
        heading: "Our Process From Concept to Comfort",
        text: "A collaborative, insight-driven process to transform spaces with textiles that embody your brand’s<br> story and elevate guest experience.",
        title1: "1. RESEARCH", img1: Con1,
        title2: "2. INSPIRATION", img2: Con6,
        title3: "3. MAPPING", img3: Con2,
        title4: "4. MOOD BOARDING", img4: Con3,
        title5: "5. MOTIFS", img5: Con7,
        title6: "6. DESIGN SHEETS", img6: Con4,
        title7: "7. SAMPLING", img7: Con5,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
      getintuch: {
         heading: "Get In Touch",
         text: "Every great idea begins with a chat. Let’s talk about your next project.",
         img1: Get2,
         img2: Get1,
         img3: Icon2,
      },
     brands:{
        img: Brand1,
      },
      services: [
        { title: "Uniform packaging", text: "per staff member", img: Ser1 },
        { title: "Logo embroidery", text: "color matching", img: Ser2 },
        { title: "Accessories", text: "like belts, ties, badges", img: Ser3 }
      ],
      clients: [
        Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8,
        Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15,
        Logo16, Logo17, Logo18, Logo19, Logo20, Logo21
      ],
      processsketch: {
        heading: "OUR PROCESS: FROM SKETCH TO STITCH",
        text: "From understanding your brand to delivering the finished product, we perfect every step.",
        title1: "1. BRAND REQUIREMENT", img1: Pro1,
        title2: "2. PRODUCT DESIGN", img2: Pro3,
        title3: "3. SAMPLING AND PRODUCT DEV", img3: Pro5,
        title4: "4. FORECASTING", img4: Pro7,
        title5: "7. DELIVERY", img5: Pro13,
        title6: "6. WAREHOUSING AND SHIPPING", img6: Pro11,
        title7: "5. MANUFACTURING", img7: Pro9,

        title8: "Share Your Vision. We’ll<br> Bring It to Life", btntext: "Get In Touch",

        img8: Pro2,
        img9: Pro4,
        img10: Pro6,
        img11: Pro12,
        img12: Pro10,
        img13: Pro8,
      },
    testimonials: [
        {
          name: "Ananya Mehta",
          position: "Senior Merchandising Manager",
          img: User1,
          text: `What I value about Saraogi Clothing is that they understand fast-changing retail trends and still deliver on time.`,
        },
        {
          name: "Rajiv Nair",
          position: "Employee Welfare & Operations",
          img: User2,
          text: `Our factory staff uniforms from Saraogi have lasted far longer than expected, and the comfort feedback from workers has been very positive.`,
        },
        {
          name: "Natasha Singh",
          position: "Director – Guest Experience",
          img: User3,
          text: `The housekeeping and front desk uniforms they designed for us are both elegant and practical, our team loves wearing them.`,
        },
        {
          name: "Emma Collins",
          position: "Senior Buyer – Womenswear",
          img: User3,
          text: `We've worked with many suppliers, but Saraogi Clothing stands out for their reliability and attention to fabric detail.`,
        },
        {
          name: "Lukas Weber",
          position: "Procurement Manager",
          img: User3,
          text: `Their workwear solutions are practical and long-lasting, our technicians noticed the difference almost immediately.`,
        },
        {
          name: "Aisha Al Mansoori",
          position: "Head of Operations",
          img: User3,
          text: `Saraogi delivered exactly what we needed—uniforms that reflect luxury while staying comfortable through long shifts.`,
        },
      ],
      getInTouch: { bg: Get1, img: Get2 }
    }
  },
  // Aap dusre product ka object yahan add kar sakte ho
];
